module.exports = __webpack_public_path__ + "img/admins.98eb1022.svg";